$(document).on("revelation__s27_gift rendered", {}, function (event, uniqueId) {
  var $this = $("#" + uniqueId);

  // console.log(event);
  // console.log(uniqueId);
  // console.log($this);
  $(".gift").each(function () {
    $(this).on("click", function () {
      $("#popup_reward").addClass("active popup_gift");
      return false;
    });
  });
});
